import Vue from 'vue';
import VueInputAutowidth from 'vue-input-autowidth'

Vue.use(VueInputAutowidth)
